import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetInboxTabCountQuery,
  GetInboxTabCountQueryVariables,
} from "./GetInboxTabCount.generated";

const GET_INBOX_TAB_COUNT: TypedDocumentNode<
  GetInboxTabCountQuery,
  GetInboxTabCountQueryVariables
> = gql`
  query getInboxTabCount(
    $startDate: DateTime
    $endDate: DateTime
    $teamUuid: String
    $userUuids: [String]
    $jobType: String
    $searchQuery: String
  ) {
    inboxTabCount(
      startDate: $startDate
      endDate: $endDate
      teamUuid: $teamUuid
      userUuids: $userUuids
      jobType: $jobType
      searchQuery: $searchQuery
    ) {
      numSavedDrafts
      numNowProcessing
      numForReview
      numForExport
      numExportedItems
    }
  }
`;

export default GET_INBOX_TAB_COUNT;
